export const CUSTOMER_TYPE = Object.freeze({
  REGULAR: 'REGULAR',
  DISTRIBUTOR: 'DISTRIBUTOR',
});

